import React from "react";
import styles from "./ProgressSteps.module.scss";
import classNames from "classnames";
import { AppDispatch, useAppDispatch } from "utils/store";
import { digitsToHindi } from "@bale/utils";

type Step = {
  label: string;
  step: number;
  callback?: (dispatch: AppDispatch) => void;
};
type Props = {
  steps: Step[];
  currentStep: number;
  showOnmobile?: boolean;
};

export function ProgressSteps(props: Props) {
  const progressPercentage =
    (100 / (props.steps.length - 1)) * (props.currentStep - 1);
  const dispatch = useAppDispatch();

  const stepClickHandler = (step: Step) => {
    if (step.step >= props.currentStep) {
      return;
    }
    step.callback?.(dispatch);
  };
  return (
    <>
      <style>{`#progresscontainer:after { width: ${progressPercentage}%; }`}</style>
      <div
        id="progresscontainer"
        className={classNames(styles.MainContainer, {
          [styles.Hide]: !props.showOnmobile,
        })}
      >
        {props.steps.map((step, index) => {
          const isPassed = index < props.currentStep;
          return (
            <div
              key={index}
              className={classNames(styles.StepWrapper, {
                [styles.PassedStep]: isPassed,
                [styles.Cursor]: isPassed && step?.callback,
              })}
              onClick={() => stepClickHandler(step)}
            >
              <div className={styles.StepLabel}>{step.label}</div>
              <div
                className={classNames(styles.StepNumber, {
                  [styles.PassedNumber]: isPassed,
                })}
              >
                {digitsToHindi(String(index + 1))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
